import { combineReducers } from 'redux'
import { AdvisorAppState, AdvisorDataState } from 'components/features/coaching/advisorStore/interfaces/state'
import { advisorsReducer, advisorsPaginationReducer, advisorsRequestReducer, advisorsVisibleReducer } from 'components/features/coaching/advisorStore/reducers/advisorsReducer'
import { timeslotsReducer, timeslotsPaginationReducer, timeslotsRequestReducer } from 'components/features/coaching/advisorStore/reducers/timeslotsReducer'
import { createMeetingReducer } from 'components/features/coaching/advisorStore/reducers/createMeetingReducer'
import { meetingsListReducer } from 'components/features/coaching/advisorStore/reducers/meetingsListReducer'
import { videoCallDetailsReducer } from 'components/features/coaching/advisorVideoCall/reducers/videoCallDetailsReducer'
import { cancelMeetingReducer } from 'components/features/coaching/advisorStore/reducers/cancelMeetingReducer'
import { reviewRequestReducer } from 'components/features/coaching/advisorStore/reducers/reviewRequestReducer'
import { usernameToUidReducer } from 'components/features/coaching/advisorStore/reducers/usernameToUidReducer'
import { ratingBreakdownReducer } from 'components/features/coaching/advisorStore/reducers/ratingBreakdownReducer'
import { reviewsReducer, reviewsPaginationReducer } from 'components/features/coaching/advisorStore/reducers/reviewsReducer'
import { topAdvisorsReducer, topReviewsReducer } from 'components/features/coaching/advisorStore/reducers/advisorLandingReducer'

export const advisorsApp = combineReducers<AdvisorAppState>({
  advisorsVisible: advisorsVisibleReducer,
})

export const advisorsData = combineReducers<AdvisorDataState>({
  advisors: advisorsReducer,
  advisorsRequest: advisorsRequestReducer,
  advisorsPagination: advisorsPaginationReducer,

  timeslots: timeslotsReducer,
  timeslotsPagination: timeslotsPaginationReducer,
  timeslotsRequest: timeslotsRequestReducer,

  createMeetingRequest: createMeetingReducer,
  meetings: meetingsListReducer,
  videoCallDetails: videoCallDetailsReducer,
  cancelMeetingRequest: cancelMeetingReducer,

  reviewRequest: reviewRequestReducer,
  usernameToUid: usernameToUidReducer,
  ratingBreakdown: ratingBreakdownReducer,

  reviews: reviewsReducer,
  reviewsPagination: reviewsPaginationReducer,

  topAdvisors: topAdvisorsReducer,
  topReviews: topReviewsReducer,
})
